<template>
  <div class="services-hot-line" v-if="isShow">
    <div class="content-wrap">
      <img
        class="close-icon"
        src="@/assets/html5/icon_close@2x.png"
        @click="isShowFn"
      >

      <p class="title">{{ $t('APP-FIELD-0227') }}</p>

      <div v-if="!agencyBanking">
        <div class="flex-box">
          <p class="label">{{ $t('APP-FIELD-0228') }}</p>
          <div>
            <p class="phone-text">{{ $t('APP-FIELD-0233') }}</p>
            <p class="phone-text">{{ $t('APP-FIELD-0234') }}</p>
          </div>
        </div>

        <div class="flex-box">
          <p class="label">{{ $t('APP-FIELD-0229') }}</p>
          <div>
            <p class="phone-text">{{ $t('APP-FIELD-0253') }}</p>
            <p class="phone-text">{{ $t('APP-FIELD-0254') }}</p>
          </div>
        </div>


        <div class="flex-box">
          <p class="label">{{ $t('APP-FIELD-0230') }}</p>
          <div>
<!--            <p class="phone-text">{{ $t('APP-FIELD-0238') }}</p>-->
            <a class="phone-text" :href="`mailto:${ $t('APP-FIELD-0238') }`">{{$t('APP-FIELD-0238')}}</a>
          </div>
        </div>
      </div>

      <div v-if="agencyBanking">
        <div class="flex-box">
          <p class="label">{{ $t('APP-FIELD-0228') }}</p>
          <div>
            <p class="phone-text">{{ $t('APP-FIELD-0240') }}</p>
          </div>
        </div>

        <div class="flex-box">
          <p class="label">{{ $t('APP-FIELD-0229') }}</p>
          <div>
            <p class="phone-text">{{ $t('APP-FIELD-0235') }}</p>
          </div>
        </div>

        <div class="flex-box">
          <p class="label">{{ $t('APP-FIELD-0231') }}</p>
          <div>
            <p class="phone-text">{{ $t('APP-FIELD-0237') }}</p>
          </div>
        </div>

        <div class="flex-box">
          <p class="label">{{ $t('APP-FIELD-0230') }}</p>
          <div>
<!--            <p class="phone-text">{{ $t('APP-FIELD-0239') }}</p>-->
            <a class="phone-text" :href="`mailto:${ $t('APP-FIELD-0239') }`">{{ $t('APP-FIELD-0239') }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ServicesHotLine",

    props: {
      isShow: {
        type: Boolean,
        default: false
      },

      agencyBanking: {
        type: Boolean,
        default: false,
      }
    },

    model: {
      prop: 'isShow',
      event: 'returnShowFn'
    },

    methods: {
      isShowFn() {
        this.$emit('returnShowFn', !this.isShow);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .services-hot-line {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.30);
    z-index: 1000;

    .content-wrap {
      position: absolute;
      width: 500px;
      /*height: 347px;*/
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 50px 40px 32px;
      background: #FFFFFF;
      border-radius: 14px;
      box-sizing: border-box;

      .close-icon {
        position: absolute;
        top: 25px;
        right: 12px;
        width: 30px;
        cursor: pointer;
      }

      .title {
        font-family: Nunito-Bold;
        font-size: 24px;
        color: #2C405A;
        text-align: left;
        margin-bottom: 15px;
      }

      .flex-box {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        margin-top: 16px;
        .label {
          font-family: Nunito-Regular;
          font-size: 14px;
          color: #2E2E2E;
          text-align: left;
        }
        .phone-text {
          font-family: Roboto-Medium;
          font-size: 14px;
          color: #11A0F8;
          letter-spacing: 0;
          /*line-height: 32px;*/
          /*min-height: 32px;*/
          margin-bottom: 12px;
          text-align: right;
          cursor: pointer;
        }
      }

      .email-label {
        font-family: Roboto-Regular;
        font-size: 16px;
        color: #000000;
        margin-top: 32px;
        text-align: left;
      }
      .email-text {
        font-family: Roboto-Medium;
        font-size: 14px;
        color: #11A0F8;
        text-align: left;
        margin: 10px 0;
      }
    }
  }
</style>